module.exports = __webpack_public_path__ + "static/media/method_frequency_infographic.5e304232.svg";